const FooterData =[
    {
       UsefulLinks:[
          {
             ClassHead:"maine-head",
             Title:"Our Services"
          },
          {
             Link:"#",
             Title:"Web Design"
          },
          {
             Link:"#",
             Title:"Web Development"
          },
          {
             Link:"#",
             Title:"API Documentation"
          }
       ],
       Services:[
          {
             ClassHead:"maine-head",
             Title:"Our Services"
          },
          {
             Link:"#",
             Title:"Web Development"
          },
          {
             Link:"#",
             Title:"API Documentation"
          },
          {
             Link:"#",
             Title:"API Documentation"
          }
       ],
       Contact:[
          {
             ClassHead:"maine-head",
             Title:"Get in touch"
          },
          {
             ClassHead:"email-input",
             Title:"Get in touch"
          },
          {
             Link:"#",
             Title:"Web Design"
          },
          {
             Link:"#",
             Title:"Web Development"
          },
          {
             Link:"#",
             Title:"API Documentation"
          }
       ]
    }
 ];
 export default FooterData;